export const STORAGE_KEY = {
  eventDraft: 'event_draft',
  eventEditDrafts: 'event_edit_drafts',
  locationDraft: 'location_draft',
  paymentsOnboardingDraft: 'payments_onboarding_draft',
  seatingPlanDraft: 'seating_plan_draft',
  seatingPlanGrid: 'seating_plan_grid',
  seatingPlanInspector: 'seating_plan_inspector',
  eventWizardLocationReturn: 'event_wizard_location_return',
  eventWizardAnchor: 'event_wizard_anchor',
  eventWizardExpandedTickets: 'event_wizard_expanded_tickets',
  eventWizardCollapsedSections: 'event_wizard_collapsed_sections',
  securitySettingsCollapsedSections: 'security_settings_collapsed_sections',
  email: 'email',
  returnUrl: 'return_url',
  lastActivityAt: 'last_activity_at',
} as const;

export type StorageKey = (typeof STORAGE_KEY)[keyof typeof STORAGE_KEY];

export const USER_SCOPED_STORAGE_KEYS: readonly StorageKey[] = [
  STORAGE_KEY.eventDraft,
  STORAGE_KEY.eventEditDrafts,
  STORAGE_KEY.locationDraft,
  STORAGE_KEY.paymentsOnboardingDraft,
  STORAGE_KEY.eventWizardLocationReturn,
  STORAGE_KEY.eventWizardAnchor,
  STORAGE_KEY.eventWizardExpandedTickets,
  STORAGE_KEY.eventWizardCollapsedSections,
  STORAGE_KEY.securitySettingsCollapsedSections,
  STORAGE_KEY.email,
];

export const USER_SCOPED_STORAGE_KEY_PREFIXES: readonly StorageKey[] = [
  STORAGE_KEY.seatingPlanDraft,
];
